import APIRequest from '@geenee/builder/src/lib/APIRequest';

// @ts-ignore
export const updateProfile = async (data: Record<string, any>) => APIRequest.put(`/api/v0/account/user`, data);
